import { z } from "zod/v4";

// Function to recursively get field names from a Zod schema
export const getZodSchemaKeys = (schema: z.ZodObject): string[] => {
  const paths = new Set<string>();

  const extractPaths = (schema: z.ZodObject, prefix: string = "") => {
    const shape = schema.shape;
    Object.keys(shape).forEach((key) => {
      let field = shape[key];
      const path = prefix ? `${prefix}.${key}` : key;

      while (true) {
        if (
          field instanceof z.ZodNullable ||
          field instanceof z.ZodOptional ||
          field instanceof z.ZodDefault
        ) {
          field = field.unwrap();
        } else if (field instanceof z.ZodArray) {
          field = field.element;
        } else {
          break;
        }
      }

      if (field instanceof z.ZodObject) {
        extractPaths(field, path);
      } else {
        paths.add(path);
      }
    });
  };

  extractPaths(schema);
  return Array.from(paths);
};

export function cleanParse<T extends z.ZodObject<any>>(
  schema: T,
  data: unknown
): z.infer<T> | Partial<z.infer<T>> {
  const result = schema.safeParse(data);

  if (result.success) {
    return result.data;
  }

  const shape = schema.shape;
  const cleaned: Partial<z.infer<T>> = {};

  for (const key in shape) {
    const fieldSchema = shape[key];
    const value = (data as any)?.[key];

    if (value !== undefined) {
      const fieldResult = fieldSchema.safeParse(value);
      if (fieldResult.success) {
        (cleaned as any)[key] = fieldResult.data;
      }
    }
  }

  return cleaned;
}
